import type { Tealium } from 'src/types/appState';

import { EVENT_VIEW_EDIT } from '../constants';

export const eventName = EVENT_VIEW_EDIT;

export default (tealium: Tealium) => {
  const { previousPageName, sourceJobId } = tealium;
  return {
    isEcajaStart: !previousPageName,
    jobId: sourceJobId,
  };
};
